import I18n from 'I18n';

export default (amount: number | string, currencyCode: string): string => {
  return I18n.text('i18n.numberRepresentation.numberWithCurrencyCode', {
    amountNumberValue: amount,
    currencyCode,
  });
};
